import './ErrorPage.css';

interface ErrorPageProps {
	error: Error | null;
}

export default function ErrorPage({ error }: ErrorPageProps) {
	return (
		<div id="error-page" className="page" role="alert">
			<section className="wrapper">
				<h1>500</h1>
				<h4>Error Page</h4>
				<p>Please try refreshing the page.</p>
				{__DEV__ && <pre>{error?.message}</pre>}
			</section>
		</div>
	);
}
